var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon",class:{ 'icon-spin': _vm.spin }},[_c('use',{attrs:{"xlink:href":("#" + _vm.icon)}})])}
var staticRenderFns = []

export { render, staticRenderFns }